module.exports = __webpack_public_path__ + "static/media/AWC_Brand_dark.20ab83bd.svg";